import SessionIcon from '../../assets/icons/session.svg?react';
import { Button } from '../Button/Button';
import { Message } from '../Messages/Message';
import { Column } from '../Column/Column';
import { NotificationPage } from '../NotificationPage/NotificationPage';
import { useThemeContext } from '../../../features/Theme/providers/ThemeContextProvider';
import { useTranslationsContext } from '../../../features/Translations/providers/TranslationsContextProvider';

export interface ErrorProps {
	type: 'error' | 'warning' | 'success'
	title: string;
	message: string;
	onRetry?: () => void;
}

export function AlertModal({ type, title, message, onRetry }: ErrorProps) {
	const theme = useThemeContext();
	const { t } = useTranslationsContext();

	return (
		<NotificationPage
			prepend={<SessionIcon fill={theme.colors.brand.primary[300]} width={25} height={25} />}
			title={title}
		>
			<Column $spaceBetween $fillHeight $gap={32}>
				<Message message={message} type={type}></Message>
				{onRetry && (
					<Button
						onClick={() => {
							onRetry();
						}}
						$color={'primary'}
						$block
					>
						{t('common.retry')}
					</Button>
				)}
			</Column>
		</NotificationPage>
	);
}
